import { Box, Typography, styled } from '@mui/material'
import { ReactComponent as EmptyStateIcon } from './EmptyState.svg'

const StyledGridOverlay = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '473px',
  '& .ant-empty-img-1': {
    fill: theme.palette.mode === 'light' ? '#aeb8c2' : '#262626',
  },
  '& .ant-empty-img-2': {
    fill: theme.palette.mode === 'light' ? '#f5f5f7' : '#595959',
  },
  '& .ant-empty-img-3': {
    fill: theme.palette.mode === 'light' ? '#dce0e6' : '#434343',
  },
  '& .ant-empty-img-4': {
    fill: theme.palette.mode === 'light' ? '#fff' : '#1c1c1c',
  },
  '& .ant-empty-img-5': {
    fillOpacity: theme.palette.mode === 'light' ? '0.8' : '0.08',
    fill: theme.palette.mode === 'light' ? '#f5f5f5' : '#fff',
  },
}))

export function CustomNoRowsOverlay() {
  return (
    <StyledGridOverlay>
      <EmptyStateIcon />
      <Box
        sx={{
          mt: 2,
          gap: '.5rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="h6" align="center" sx={{ color: '#666', fontSize: '1rem' }}>
          Não há números de telefone cadastrados
        </Typography>
        <Typography variant="body1" align="center" sx={{ color: '#666', fontSize: '.8rem', width: '70%' }}>
          Você ainda não possui números de telefone cadastrados na Meta para WhatsApp.
        </Typography>
      </Box>
    </StyledGridOverlay>
  )
}
